import { render, staticRenderFns } from "./Access-Denied.vue?vue&type=template&id=29f3d6e0&lang=pug"
import script from "./Access-Denied.vue?vue&type=script&lang=ts"
export * from "./Access-Denied.vue?vue&type=script&lang=ts"
import style0 from "./Access-Denied.vue?vue&type=style&index=0&id=29f3d6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports